export default "__VITE_ASSET__4fb2488d__"